import { ComponentSingleStyleConfig } from "@chakra-ui/react";

const button: ComponentSingleStyleConfig = {
  baseStyle: {
    rounded: "8px",
    fontWeight: 500,
    _focus: {
      boxShadow: "0 0 0 3px #d0308d52"
    },
    _focusVisible: {
      boxShadow: "0 0 0 3px #d0308d52"
    }
  },
  sizes: {
    md: {
      h: 50
    }
  },
  variants: {
    solid: {
      background: "primary.500",
      color: "white",
      _hover: {
        background: "primary.500",
        _disabled: { background: "primary.300" }
      },
      _focus: { background: "primary.500" },
      _active: { background: "primary.500" },
      _disabled: { background: "primary.300" }
    }
  },
  defaultProps: {
    variant: "solid" // default was solid
  }
};

export default button;
